import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AboutUsComponent} from './about-us/about-us.component';
import {ContactComponent} from './contact/contact.component';
import {CommentComponent} from './comment/comment.component';
import {WhoWeAreComponent} from './who-we-are.component';

const routes: Routes = [
    {path: 'kik-vagyunk', component: WhoWeAreComponent},
    {path: 'rolunk', component: AboutUsComponent},
    {path: 'kapcsolat', component: ContactComponent},
    {path: 'komment', component: CommentComponent},
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class WhoWeAreRoutingModule {}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/who-we-are/who-we-are-routing.module.ts